<template>
  <div class="templateConfigDetail">
    <module-container
      :title="titleName"
      header-padding-top="0px"
      :padding="false"
    >
      <div class="templateConfigDetail__content">
        <templateStyle
          ref="templateStyleForm"
          :show-template-style-id="false"
        ></templateStyle>
        <footer>
          <el-button type="primary" @click="save" :loading="submitLoading"
            >保存</el-button
          >
        </footer>
      </div>
    </module-container>
  </div>
</template>

<script>
import ModuleContainer from '@comp/moduleContainer'
import templateStyle from '@/components/templateStyle'
import { Get, Post, ProjectConfig } from '@/api'
const increment = ProjectConfig.increment
import { mapState } from 'vuex'

export default {
  name: 'TemplateConfigDetail',
  props: {
    templateOptions: {
      type: Array,
      default: () => []
    }
  },
  components: {
    ModuleContainer,
    templateStyle
  },
  data() {
    return {
      tempOptions: [],
      type: '',
      submitLoading: false,
      details: {}
    }
  },
  computed: {
    ...mapState('micro/user', ['userInfo']),
    titleName() {
      return (
        (this.tempOptions.find((item) => item.value.toString() === this.type)
          ?.label || '') + '模板'
      )
    }
  },
  watch: {
    templateOptions: {
      handler(newVal) {
        this.tempOptions = [...newVal]
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.type = this.$route.query.type
    this.GetTemplateDetail()
  },
  methods: {
    save() {
      this.$refs.templateStyleForm.$refs.ruleForm.validate(
        (valid, invalidFields) => {
          if (valid) {
            let params = {
              ...this.details,
              ...this.$refs.templateStyleForm.ruleForm,
              operatorName: this.userInfo.name
            }
            this.submitLoading = true
            Post(increment.EditTemplate.url, params)
              .then((res) => {
                console.log(res.data)
                if (res.data.status === 0) {
                  this.$message({
                    message: res.data.message || '操作成功',
                    type: 'success'
                  })
                  this.GetTemplateDetail()
                } else {
                  this.$message({
                    message: res.data.message || '操作失败',
                    type: 'error'
                  })
                }
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            this.scrollToFirstError(invalidFields)
            return false
          }
        },
        true
      )
    },
    // 表单校验失败，滚动到第一个错误字段
    scrollToFirstError(invalidFields) {
      setTimeout(() => {
        const formEl = this.$refs.templateStyleForm.$refs.ruleForm.$el
        if (!formEl) return
        // 查找第一个错误的表单项
        const errorItem = formEl.querySelector('.el-form-item.is-error')
        const targetItem =
          errorItem ||
          (invalidFields &&
            formEl.querySelector(
              `[data-path="${Object.keys(invalidFields)[0]}"]`
            ))
        if (!targetItem) return
        // 找到 .page-content 滚动容器
        const scrollBody = document.querySelector('.page-content')
        if (!scrollBody) return
        const rect = targetItem.getBoundingClientRect()
        const bodyRect = scrollBody.getBoundingClientRect()
        const relativeTop = rect.top - bodyRect.top + scrollBody.scrollTop - 80
        scrollBody.scrollTo({ top: relativeTop, behavior: 'smooth' })
      }, 50)
    },
    GetTemplateDetail() {
      Get(increment.GetTemplateDetail.url, {
        params: {
          templateId: this.$route.query.templateId
        }
      }).then((res) => {
        if (res && res.data && res.data.status === 0) {
          this.details = res.data.data
          this.$refs.templateStyleForm.setData(res.data.data)
        } else {
          const { message = '' } = res.data
          this.$message.error(message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.templateConfigDetail {
  footer {
    padding: 20px 0;
    width: 100%;
    text-align: center;
  }
}
</style>
